import { ProcessedMessage } from './useProcessMessage'
import useUser from '../useUser'
import { useHistory, useLocation } from 'react-router-dom'
import { Command, IBackgroundLocationState } from '../../config/appConfig'
import { COMMAND_PREFIX } from '../../pages/Commands'
import { TimeTrackingNotification } from './useProcessTimeTrackingNotification'
import { toast } from 'react-toastify'
import { toastContainerId } from '../../pages/App'
import { useContext } from 'react'
import PopupContext from '../../context/PopupContext'
import { ModuleType } from '../../context/GlobalContext'
import useRoles, { rolesWriteAllTimes } from '../useRoles'
import useModules from '../module/useModules'

/**
 * Message in order to revoke a TimeSuggestionDialog.
 */
export type CancelTimeTrackingNotification = ProcessedMessage<{
    timeSuggestionId: string
}>

/**
 * Process a cancel time tracking event message. This revokes the TimeSuggestionDialog.
 */
export default function useProcessCancelTimeTrackingNotification() {
    const history = useHistory<IBackgroundLocationState>()
    const { currentUser } = useUser()
    const location = useLocation<TimeTrackingNotification>()
    const modules = useModules()
    const popupContext = useContext(PopupContext)
    const roles = useRoles()

    return (message: CancelTimeTrackingNotification) => {
        if (!modules.has(ModuleType.TimeTracking) || !roles.any(rolesWriteAllTimes) || currentUser?.useTimePopup === false) {
            // Only navigate away from the time tracking popup when the user actually uses the popups.
            return
        }

        if (message.data?.timeSuggestionId === undefined) {
            return
        }

        toast.dismiss({ id: message.data.timeSuggestionId, containerId: toastContainerId })
        popupContext.cancelTimeSuggestionDialog(message.data.timeSuggestionId)

        //Only cancel the time tracking dialog when the timeSuggestionId match.
        if (
            location.pathname === `${COMMAND_PREFIX}/${Command.TrackTime}` &&
            message.data?.timeSuggestionId === location.state?.data?.timeSuggestionId
        ) {
            history.push(history.location.state?.background?.pathname || '/')
        }
    }
}
